import dayjs from 'dayjs';
import { Observer } from 'mobx-react-lite';
import React from 'react';
import joinClassName from '../../utils/className.utils';
import { useProps, useStore } from '../../utils/mobx.utils';
var DateRenderer = function (props) {
    var p = useProps(props);
    var s = useStore(function () { return ({
        get moment() {
            return props.value ? dayjs.utc(props.value) : null;
        },
        get valueIsValid() {
            var _a;
            return (_a = s.moment) === null || _a === void 0 ? void 0 : _a.isValid();
        },
        get format() {
            var _a;
            return p.format || (((_a = s.moment) === null || _a === void 0 ? void 0 : _a.isSame('', 'year')) ? 'MMM D, HH:mm' : 'MMM D YYYY, HH:mm');
        },
        get isToday() { var _a; return (_a = s.moment) === null || _a === void 0 ? void 0 : _a.isSame('', 'day'); },
        get isYesterday() { var _a; return (_a = s.moment) === null || _a === void 0 ? void 0 : _a.add(1, 'day').isSame('', 'day'); },
        get isTomorrow() { var _a; return (_a = s.moment) === null || _a === void 0 ? void 0 : _a.subtract(1, 'day').isSame('', 'day'); },
        get formattedTime() { return s.moment ? dayjs.utc(s.moment).local().format('HH:mm') : '--:--'; },
        get displayValue() {
            if (p.value && !s.valueIsValid)
                return 'Invalid Date';
            if (p.timeOnlyIfToday && s.isToday) {
                return 'Today, ' + s.formattedTime;
            }
            if (p.timeOnlyIfYesterday && s.isYesterday) {
                return 'Yesterday, ' + s.formattedTime;
            }
            if (p.timeOnlyIfTomorrow && s.isTomorrow) {
                return 'Tomorrow, ' + s.formattedTime;
            }
            var value = s.moment ? (s.valueIsValid ? dayjs.utc(s.moment).local().format(s.format) : p.value) : p.emptyValue || '';
            return value === '0000-00-00' ? '' : value;
        },
    }); });
    return React.createElement(Observer, { children: function () { return (props.value ? React.createElement("time", { className: joinClassName('DateRenderer', p.className) }, s.displayValue) : null); } });
};
export default DateRenderer;
